/**
 * The in-app path in a raw `?to=` value, or null when it is missing or could leave the app.
 *
 * `to` is read raw from the URL, so only trust an in-app absolute path. Reject
 * protocol-relative ('//host') and backslash ('/\\host', which some browsers normalise
 * to '//') values that would otherwise redirect to an external origin. Defense-in-depth:
 * React Router's navigate() already treats these as in-app paths, but a validated path
 * is cheaper than relying on that.
 */
export const getInternalRedirectPath = (rawTo: string | null): string | null =>
  typeof rawTo === 'string' &&
  rawTo.startsWith('/') &&
  !rawTo.startsWith('//') &&
  !rawTo.startsWith('/\\')
    ? rawTo
    : null;
